<div class="btn-group" dropdown   style="width:100%;height: 100%;" >
    <button type="submit" 
            title="{{selectedOpcion}}" 
            id="boton-submit"
            style="overflow: hidden;white-space: nowrap;text-overflow: unset;width:85%;height: 100%;" 
            class="btn btn-primary mt-2" 
            (click)="selectedNavItem()" 
            class="{{classBoton}}"
            [disabled]="disabled">
      {{selectedOpcion}}
    </button>
    <button id="boton-listado" type="button" (click)="despliegaOpciones()" *ngIf="desplegableVisible == true" class="btn btn-primary mt-2 dropdown-toggle dropdown-toggle-split"
            aria-controls="dropdown-split"
            style="width:15%;height: 100%;" >
      <span class="caret"></span>
      <span class="sr-only visually-hidden">Boton listado</span>
    </button>
    
    <ul id="listado-split"  class="dropdown-menu"
        role="menu" aria-labelledby="button-split">
      <li *ngFor="let opcion of opcionesListado"  role="menuitem">
        <a class="dropdown-item"  (click)="onSelect(opcion)">{{opcion}}</a>
      </li>
    </ul>
  </div>